import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import GalleryService from '../../../services/gallery.service';

const GalleryPreview = ({
  t,
  errors,
  images,
  isImage,
  currentPage,
  onErrorImage,
  downloadLink,
  activeDocument,
  showComments,
  sliderSettings,
  backgroundColor,
}) => (
  <div className="gpreviewscrollto">
    {errors ?
      <div className="nopreview boxs chosefl chosefl1">
        <h2 className="fontmulisemi">{t('No preview available')}</h2>
      </div> :

      <div className="docpreview boxs chosefl chosefl2">
        {/* <div className="arrowtop">
          <div className="download">
            <ul>
              <li className="actiondiv">
                <a
                  href={downloadLink}
                  className="actionlink"
                >{t('Download')}
                  <i
                    className="fa fa-caret-down car-l"
                    aria-hidden="true"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div> */}
        {!!isImage ? <Slider {...sliderSettings}>
          {Object.keys(images).map(i => (
            <div className="docfile boxs" key={i}>
              <img src={images[i]} alt="imgfile" onError={onErrorImage} />
            </div>
            ))}
        </Slider> :
        <Slider {...sliderSettings}>
        <div className="docfile boxs">
          <img src={images[0]} alt="imgfile" onError={onErrorImage} className="docfile-img" />
        </div>
        </Slider>
        }
      </div>
    }
  </div>

);

GalleryPreview.propTypes = {
  errors: PropTypes.bool,
  images: PropTypes.object,
  t: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  activeDocument: PropTypes.object,
  onErrorImage: PropTypes.func.isRequired,
  sliderSettings: PropTypes.object.isRequired,
  backgroundColor: PropTypes.string,
};

export default GalleryPreview;



// WEBPACK FOOTER //
// ./src/components/modules/galleryPreview/GalleryPreview.jsx